var _mask, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgTicket = function SvgTicket(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 14 8"
  }, props), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "ticket_svg__a",
    width: 15,
    height: 9,
    x: -0.5,
    y: -0.5,
    fill: "#000",
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M-.5-.5h15v9h-15z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.5 2.5a1.5 1.5 0 0 0 0 3v2H.5v-2a1.5 1.5 0 1 0 0-3v-2h13z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M13.5 2.5a1.5 1.5 0 0 0 0 3v2H.5v-2a1.5 1.5 0 1 0 0-3v-2h13z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M13.5 2.5V3h.5v-.5zm0 3h.5V5h-.5zm0 2V8h.5v-.5zm-13 0H0V8h.5zm0-2V5H0v.5zm0-3H0V3h.5zm0-2V0H0v.5zm13 0h.5V0h-.5zm0 2V2a2 2 0 0 0-2 2h1a1 1 0 0 1 1-1zM12 4h-.5a2 2 0 0 0 2 2V5a1 1 0 0 1-1-1zm1.5 1.5H13v2h1v-2zm0 2V7H.5v1h13zm-13 0H1v-2H0v2zm0-2V6a2 2 0 0 0 2-2h-1a1 1 0 0 1-1 1zM2 4h.5a2 2 0 0 0-2-2v1a1 1 0 0 1 1 1zM.5 2.5H1v-2H0v2zm0-2V1h13V0H.5zm13 0H13v2h1v-2z",
    mask: "url(#ticket_svg__a)",
    style: {
      fill: "var(--ticket-outline-color, white)"
    }
  }));
};
export default SvgTicket;